import { useState } from 'react'

import { Button, Checkbox, Modal, Trans } from '@/components'

export function EraseDataModal(props: {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  domainNames?: string[]
  dataDriveConfig?: number
  snapshotConfig?: number
}) {
  const { open, onClose, onConfirm, domainNames, dataDriveConfig = 0, snapshotConfig = 0 } = props
  const [isChecked, setIsChecked] = useState(false)

  const getCheckboxMessage = () => {
    const renderList = (showSnapshots: boolean, showRegions: boolean) => (
      <div>
        Check to confirm deletion of <span className="text-error">ALL DATA</span> in:
        <ul className="list-disc pl-4 mt-2 space-y-1">
          {showSnapshots && <li>Snapshots</li>}
          {showRegions && domainNames?.map((name) => <li key={name}>{name} Region</li>)}
        </ul>
      </div>
    )

    if (dataDriveConfig === 0 && snapshotConfig === 0) {
      return renderList(true, true)
    }
    if (dataDriveConfig === 0) {
      return renderList(false, true)
    }
    if (snapshotConfig === 0) {
      return renderList(true, false)
    }
    return renderList(true, true)
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>
        <Trans i18nKey="space.eraseDataModalTitle">Data Delete Confirmation</Trans>
      </Modal.Header>
      <Modal.Body>
        <div className="t-lg">
          This action will{' '}
          <span className="text-error">permanently delete all data stored in Storage.</span>
        </div>
        <div className="mt-4 bg-error/10 p-4 rounded-lg flex items-start cursor-pointer">
          <label className="flex items-start w-full cursor-pointer">
            <Checkbox
              checked={isChecked}
              onChange={(checked) => setIsChecked(checked)}
              checkedBgColor="bg-error"
              checkedBorderColor="border-error"
              checkIconColor="text-error"
            />
            <span className="ml-2 text-secondary t-s-sb">{getCheckboxMessage()}</span>
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="outline" onClick={onClose}>
          <Trans i18nKey="space.eraseDataModalCancel">Cancel</Trans>
        </Button>
        <Button type="danger" onClick={onConfirm} disabled={!isChecked}>
          <Trans i18nKey="space.eraseDataModalConfirm">Confirm</Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
